<template>
  <div v-if="printer">
    <h1>Scanner</h1>
    <v-btn
      :to="{name:'scanners', query:{objectType:$route.query.objectType, objectId:$route.query.objectId}}"
    >
      <v-icon>chevron_left</v-icon>Scanners
    </v-btn>
    <EntityWorking :entity="entity" v-if="entity" />
    <FileWorking :file="file" v-if="file" />
    <p>
      <strong>This scanner is:&#160;</strong>
      <span>{{printer.code}}</span>
      <span>&#160;-&#160;</span>
      <span>{{printer.name}}</span>
    </p>
    <div v-for="(scanDay, index) in computedScanDays" :key="`scanday${index}`">
      <h3>{{scanDay.date | formatDate}}</h3>
      <table>
        <tr v-for="(scan, scanindex) in scanDay.scans" :key="`scan${scanindex}`">
          <td>{{scan.lastModified | formatTime}}</td>
          <td>
            <router-link
              :to="{name:'scan', params:{id:printer.id}, query:{name:scan.name, objectType:$route.query.objectType, objectId:$route.query.objectId}}"
            >{{scan.name}}</router-link>
          </td>
          <td>
            <span class="scanTotal">{{`(${scan.count} pages)`}}</span>
          </td>
          <td>
            <v-btn @click="deleteScan(scan)" color="error" small>
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import EntityWorking from "@/components/link/EntityWorking";
import FileWorking from "@/components/link/FileWorking";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Scanner",
  metaInfo() {
    return {
      title: "Scanner",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    EntityWorking,
    FileWorking
  },
  computed: {
    computedScanDays() {
      if (!this.scans) {
        return undefined;
      }
      return this.scans.reduce((r, a) => {
        const date = new Date(a.lastModified).toISOString().substr(0, 10);
        const count = this.thumbnailsCounts
          ? this.thumbnailsCounts[a.shortName]
          : undefined;
        const scan = { ...a, count };
        let current = r.find(e => e.date == date);
        if (!current) {
          r.push({
            date,
            scans: [scan]
          });
        } else {
          current.scans.push(scan);
        }
        return r;
      }, []);
    }
  },
  data() {
    return {
      entity: null,
      file: null,
      printer: null,
      scans: [],
      thumbnailsCounts: null
    };
  },
  methods: {
    fetchEntity() {
      nbmlaw
        .get(`/cors/admin/directory/entities/${this.$route.query.objectId}`)
        .then(response => {
          // console.log(response.data);
          this.entity = response.data;
        });
    },
    fetchFile() {
      nbmlaw
        .get(`/cors/admin/file/files/${this.$route.query.objectId}`)
        .then(response => {
          // console.log(response.data);
          this.file = response.data;
        });
    },
    fetchPrinter() {
      nbmlaw
        .get(`/cors/admin/extras/printers/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data);
          this.printer = response.data;
        });
    },
    fetchScans() {
      nbmlaw
        .get(`/cors/admin/document/scanners/${this.$route.params.id}/scans`)
        .then(response => {
          // console.log(response.data);
          this.scans = response.data;
        });
    },
    fetchThumbnailsCounts() {
      nbmlaw
        .get(
          `/cors/admin/document/scanners/${this.$route.params.id}/scans/thumbnails/counts`
        )
        .then(response => {
          // console.log(response.data);
          this.thumbnailsCounts = response.data;
        });
    },
    deleteScan(scan) {
      if (confirm("Are you sure?")) {
        nbmlaw
          .delete(
            `/cors/admin/document/scanners/${this.$route.params.id}/scans/chosen`,
            { params: { name: scan.name } }
          )
          .then(() => {
            // console.log(response.data);
            this.update();
          });
      }
    },
    update() {
      this.fetchPrinter();
      this.fetchScans();
      this.fetchThumbnailsCounts();
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.update();
      }
    },
    "$route.query.objectId": {
      immediate: true,
      handler() {
        this.entity = null;
        this.file = null;
        if (this.$route.query.objectId) {
          if (this.$route.query.objectType == "entity") {
            this.fetchEntity();
          } else if (this.$route.query.objectType == "file") {
            this.fetchFile();
          }
        }
      }
    }
  }
};
</script>
